import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, TwitterIcon, InstagramIcon, HomeIcon, MailIcon, PhoneIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-[#006D77] text-white" data-id="element-507">
      <div className="container mx-auto px-4 py-10" data-id="element-508">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-509">
          <div className="space-y-4" data-id="element-510">
            <div className="flex items-center space-x-2" data-id="element-511">
              <HomeIcon className="h-6 w-6 text-[#D4A017]" data-id="element-512" />
              <span className="font-bold text-xl" data-id="element-513">Minayo</span>
            </div>
            <p className="text-sm" data-id="element-514">
              Find your perfect stay anywhere in the world. Vacation homes,
              hotels, and unique accommodations for every budget.
            </p>
            <div className="flex space-x-4" data-id="element-515">
              <a href="#" className="hover:text-[#D4A017]" data-id="element-516">
                <FacebookIcon className="h-5 w-5" data-id="element-517" />
              </a>
              <a href="#" className="hover:text-[#D4A017]" data-id="element-518">
                <TwitterIcon className="h-5 w-5" data-id="element-519" />
              </a>
              <a href="#" className="hover:text-[#D4A017]" data-id="element-520">
                <InstagramIcon className="h-5 w-5" data-id="element-521" />
              </a>
            </div>
          </div>
          <div data-id="element-522">
            <h3 className="font-semibold text-lg mb-4" data-id="element-523">Explore</h3>
            <ul className="space-y-2" data-id="element-524">
              <li data-id="element-525">
                <Link to="/search" className="hover:text-[#D4A017] text-sm" data-id="element-526">
                  Find Stays
                </Link>
              </li>
              <li data-id="element-527">
                <Link to="/search?type=bnb" className="hover:text-[#D4A017] text-sm" data-id="element-528">
                  Bed & Breakfasts
                </Link>
              </li>
              <li data-id="element-529">
                <Link to="/search?type=farmstay" className="hover:text-[#D4A017] text-sm" data-id="element-530">
                  Farmstays
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-531">
            <h3 className="font-semibold text-lg mb-4" data-id="element-532">Company</h3>
            <ul className="space-y-2" data-id="element-533">
              <li data-id="element-534">
                <a href="#" className="hover:text-[#D4A017] text-sm" data-id="element-535">
                  About Us
                </a>
              </li>
              <li data-id="element-536">
                <a href="#" className="hover:text-[#D4A017] text-sm" data-id="element-537">
                  Careers
                </a>
              </li>
              <li data-id="element-538">
                <a href="#" className="hover:text-[#D4A017] text-sm" data-id="element-539">
                  Blog
                </a>
              </li>
              <li data-id="element-540">
                <a href="#" className="hover:text-[#D4A017] text-sm" data-id="element-541">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-542">
                <a href="#" className="hover:text-[#D4A017] text-sm" data-id="element-543">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-544">
            <h3 className="font-semibold text-lg mb-4" data-id="element-545">Contact</h3>
            <ul className="space-y-2" data-id="element-546">
              <li className="flex items-center space-x-2" data-id="element-547">
                <MailIcon className="h-4 w-4 text-[#D4A017]" data-id="element-548" />
                <span className="text-sm" data-id="element-549">support@minayo.co.ke</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-550">
                <PhoneIcon className="h-4 w-4 text-[#D4A017]" data-id="element-551" />
                <span className="text-sm" data-id="element-552">+254 (741) 492-962</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-600 mt-8 pt-6 text-center text-sm" data-id="element-553">
          <p data-id="element-554">© {new Date().getFullYear()} Minayo Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;